module.exports = __webpack_public_path__ + "213f2940ba412bea742776cd0429bb4c.png";